export default {
      id: "logo-usage",
      viewBox: "0 0 31 29",
      url: __webpack_public_path__ + "img/icons.svg#logo",
      toString: function () {
        return this.url;
      }
    }